import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {getFeatureUnit} from "../../../misc/helpers";

const LookFeatureQuantityText = (props) => {

  const {cartItem, intl, fabricatorData} = props;

  return getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity, cartItem)
};

LookFeatureQuantityText.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface)
}

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;
  return {
    fabricatorData,
  }
};
export default injectIntl(
  connect(mapStateToProps)(LookFeatureQuantityText)
)
